import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "stringToBoolean",
  standalone: true,
})
export class StringToBooleanPipe implements PipeTransform {
  transform(value: string): boolean | string {
    return value.toLowerCase() === "true" ? true : value.toLowerCase() === "false" ? false : value;
  }
}
